import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IModalContext, ModalChildComponentContextKey } from '../../../../../models';
import { IUserSessionComponentProps, UserSessionViewModelKey } from '../../../../../models/AppState';
import HawksoftLogoImageUrl from '../../../../../web/assets/hawksoft_logo.png';
import { asModalComponent } from '../../../../../web/components/Modal';
import { TextInput } from '../../../../../web/components/TextInput';
import { baseStyleSheet } from '../../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps extends IEventLoggingComponentProps, IUserSessionComponentProps, IModalContext<string> {
	className?: string;
	styles?: StyleDeclarationValue[];
}

interface IState {
	agencyId?: string;
}

class _HawksoftSetup extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {};
	}

	public render() {
		const { className, styles } = this.props;
		const { agencyId } = this.state;
		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} hawksoft-setup ${className || ''}`}>
				<img className={css(styleSheet.logo)} src={HawksoftLogoImageUrl} />
				<div className={css(styleSheet.label)}>Agency ID</div>
				<TextInput
					autoFocus={true}
					className={css(styleSheet.input)}
					inputId='hawksoft-setup-agency-id-input'
					onChange={this.onAgancyIdInputChanged}
					type='text'
					value={agencyId || ''}
				/>
				<button className={css(baseStyleSheet.ctaButton, styleSheet.signInButton)} onClick={this.onSignInButtonClicked}>
					<span>Sign in</span>
				</button>
			</div>
		);
	}

	private onAgancyIdInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({
			agencyId: e.target.value,
		});
	};

	private onSignInButtonClicked = () => {
		const { parentModal } = this.props;
		// TODO: make a network request
		if (parentModal) {
			parentModal.onRequestClose(this.state.agencyId, false);
		}
	};
}

const HawksoftSetupAsObserver = observer(_HawksoftSetup);
const HawksoftSetupWithContext = inject(
	UserSessionViewModelKey,
	ModalChildComponentContextKey
)(HawksoftSetupAsObserver);
const HawksoftSetup = withEventLogging(HawksoftSetupWithContext, 'HawksoftSetup');

export const HawksoftSetupModal = asModalComponent(HawksoftSetup, {
	className: css(styleSheet.modal),
	shouldCloseOnOverlayClick: false,
	useDefaultHeader: true,
});
